import { render } from "./Arena_Clone_All.vue?vue&type=template&id=27de2ae5&scoped=true"
import script from "./Arena_Clone_All.vue?vue&type=script&lang=js"
export * from "./Arena_Clone_All.vue?vue&type=script&lang=js"

import "./Arena_Clone_All.vue?vue&type=style&index=0&id=27de2ae5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27de2ae5"]])

export default __exports__